import { EntityType } from 'api'
import { createAllEntitiesHook, createEntityGetterHook, createEntityHook } from './common'
import { createReferenceDataEntityHook } from './referenceData'

export const useTradingEntity = createEntityHook(EntityType.TRADING_ENTITY)
export const useAllTradingEntities = createAllEntitiesHook(EntityType.TRADING_ENTITY)
export const useTradingEntityGetter = createEntityGetterHook(EntityType.TRADING_ENTITY)
export const useTradingEntityReferenceData = createReferenceDataEntityHook(EntityType.TRADING_ENTITY)
